import { ReactNode } from 'react';

import HorizontalSlider from '../../../../../components/HorizontalSlider/HorizontalSlider';
import FadeConfiguration from '../../../../../components/HorizontalSlider/types/FadeConfiguration';
import ListPicker from '../../../../../components/ListPicker/ListPicker';
import MaxWidth from '../../../../../components/MaxWidth/MaxWidth';
import Select from '../../../../../components/Select/Select';
import ToggleButton from '../../../../../components/ToggleButton/ToggleButton';
import useMedia, { Queries } from '../../../../../hooks/ui/useMedia';
import ErrorList from '../../../../../types/UI/ErrorList';
import useRangeAsOptions from '../../../../hooks/useRangeAsOptions';

import styles from './NumberOfBoatsPicker.module.css';

const queries: Queries<number> = {
    '(min-width: 768px)': 12,
};

const sliderFade: FadeConfiguration = {
    placement: 'both',
};

type NumberOfBoatsPickerProps = {
    max: number;
    defaultValue?: number;
    value?: number;
    onChange?: (value?: number) => void;
    label?: ReactNode;
    errors?: ErrorList;
    name?: string;
};

const NumberOfBoatsPicker = ({
    max,
    defaultValue,
    value,
    onChange,
    label,
    errors,
    name,
}: NumberOfBoatsPickerProps) => {
    const options = useRangeAsOptions(1, max);
    const visualOptions = useMedia(queries, 6);

    const handleChange = (value?: string) => {
        const intValue = value ? parseInt(value) : undefined;

        onChange && onChange(intValue);
    };

    if (options.length > visualOptions) {
        return (
            <MaxWidth width="240px">
                <Select
                    options={options}
                    variant="subtle-no-border"
                    defaultValue={defaultValue?.toString()}
                    value={value?.toString()}
                    onChange={handleChange}
                    label={label}
                    errors={errors}
                    name={name}
                />
            </MaxWidth>
        );
    }

    return (
        <HorizontalSlider fade={sliderFade}>
            <ListPicker
                inline
                options={options}
                defaultValue={defaultValue?.toString()}
                value={value?.toString()}
                onChange={handleChange}
                label={label}
                errors={errors}
                name={name}
                valueProperty="value"
                renderOption={({ option, onSelect, selected }) => {
                    return (
                        <ToggleButton
                            className={styles.Button}
                            toggled={selected}
                            onClick={onSelect}
                            fullWidth
                        >
                            {option.label}
                        </ToggleButton>
                    );
                }}
            />
        </HorizontalSlider>
    );
};

export default NumberOfBoatsPicker;
